export default __webpack_public_path__ + "static/media/roadmap1.e3607e10.png";